import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText
} from '@mui/material';

const SelectDropdown = ({
  name,
  value,
  onChange,
  options = [],
  label,
  disabled = false,
  sx = {},
  displayEmpty = false,
  error = null,
  helperText = null,
  optionValueKey = 'id',
  optionLabelKey = 'text',
  leftIcon = null, // new prop
  dropdownIcon = null, // new prop for custom dropdown indicator
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const handleChange = (event) => {
    onChange({
      target: {
        name,
        value: event.target.value
      }
    });
  };

  return (
    <FormControl fullWidth error={error} sx={sx} style={{ position: 'relative' }}>
      {label && (
        <InputLabel
          shrink={Boolean(value) || displayEmpty}
          htmlFor={`${name}-select`}
          sx={{
            backgroundColor: 'background.paper',
            px: 1,
            transform: 'translate(14px, -9px) scale(0.75)'
          }}
        >
          {label}
        </InputLabel>
      )}
      {leftIcon && (
        <span style={{
          position: 'absolute',
          left: 12,
          top: '50%',
          transform: 'translateY(-50%)',
          width: 20,
          height: 20,
          display: 'flex',
          alignItems: 'center',
          pointerEvents: 'none',
          zIndex: 2
        }}>
          {leftIcon}
        </span>
      )}
      <Select
        name={name}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        displayEmpty={displayEmpty}
        label={label}
        inputProps={{
          id: `${name}-select`,
          style: leftIcon ? { paddingLeft: 40, height: 40, minHeight: 40, boxSizing: 'border-box' } : { height: 40, minHeight: 40, boxSizing: 'border-box' },
        }}
        sx={{
          '& .MuiSelect-select': {
            paddingTop: '8px',
            paddingBottom: '8px',
            ...(leftIcon ? { paddingLeft: '40px' } : {}),
            height: '40px',
            minHeight: '40px',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            color: value ? '#6D65ED' : undefined, // Make selected value purple
          },
          minHeight: '40px',
          height: '40px',
          ...sx
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: '8px',
            },
          },
        }}
        renderValue={(selected) => {
          if (!selected) return <span style={{ color: '#979797' }}>&nbsp;</span>;
          const selectedOption = options.find(opt => opt[optionValueKey] === selected);
          return (
            <span style={{ color: '#6D65ED' }}>{selectedOption ? selectedOption[optionLabelKey] : selected}</span>
          );
        }}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        IconComponent={dropdownIcon ? (() => (typeof dropdownIcon === 'function' ? dropdownIcon(open) : dropdownIcon)) : undefined}
        {...props}
      >
        {options.length === 0 ? (
          <MenuItem disabled value="" sx={{ py: '12px', pl: '12px', fontWeight: 400, fontSize: '14px', lineHeight: '140%', letterSpacing: '0em' }}>
            No Items Found
          </MenuItem>
        ) : (
          options.map((option) => (
            <MenuItem
              key={option[optionValueKey] || option}
              value={option[optionValueKey] || option}
              sx={{ py: '12px', pl: '12px', fontWeight: 400, fontSize: '14px', lineHeight: '140%', letterSpacing: '0em' }}
            >
              {typeof optionLabelKey === 'function'
                ? optionLabelKey(option)
                : option[optionLabelKey] || option.name || option.username || option}
            </MenuItem>
          ))
        )}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectDropdown;